import React from "react";
import style from "../administration/UserManagement/AirlineRepModal/airlineRepModal.module.css";
import { Button, Grid, withStyles, createStyles, Theme, DialogTitle, IconButton, Dialog, DialogContent, Paper } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import MaterialTable from "material-table";
import { getAdditionalServiceDetails, getAdditionalServiceName } from "../../utils/additionalServices";
import PaymentDetailsAwbsServices from "../../models/PaymentDetailsAwbsServices";
import { formatCurrency } from "../../utils/currencyFormatter";
import cartStyles from '../cart/cart.module.css';
import PaymentDetailsAwbs from "../../models/PaymentDetailsAwbs";
import commonStyles from './common.module.css';
import PaymentsDetail from '../../models/PaymentDetails';

interface CreditWalletModalProps {
  modalOpen: boolean;
  handleClose: () => void;
  classes: any;
  cancelOrder: () => void;
  payments: PaymentsDetail;
}

const styles = (theme: Theme) =>
  createStyles({
    formField: {
      height: 40,
      width: "100%",
    },
    rowContainer: {
      paddingRight: 20,
    },
    marginTop10: {
      marginTop: 10,
    },
  });

const creditWalletModal = (props: CreditWalletModalProps) => {
  return (
    <Dialog
      open={props.modalOpen}
      onClose={props.handleClose}
      aria-labelledby="form-dialog-title"
      maxWidth={"sm"}
      fullWidth={true}
    >
      <DialogTitle id="form-dialog-title">
      <div className={commonStyles.dialogTitle}>
        <div className={commonStyles.name}>Cancel Order & Credit eWallet</div>
        <IconButton aria-label="Close" className={style.close} onClick={props.handleClose}>
          <CloseIcon color="primary" />
        </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <div>
          <p className={style.feeText}>You have already paid fees associated with this order. <br/> Cancelling this order will result in a credit of the fees paid to your eWallet.</p>
          <div className={ `${ commonStyles.wrapper }` }>
          <h3 className={ `${ commonStyles.header }` }> Payment Breakdown</h3>
          <MaterialTable 

            components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}

            columns={[
              { title: 'AirwayBill', field: '', cellStyle: { paddingTop: '10px', verticalAlign: 'top' },
                render: (rowData: PaymentDetailsAwbs) => {
                  return (<span>{ rowData.awb_code }-{ rowData.awb_number }</span>)
                }
              },
              { title: 'Fee', field: '', cellStyle: { paddingTop: '10px', verticalAlign: 'top' },
                render: (rowData: PaymentDetailsAwbs) => {

                  const fees: Array<JSX.Element> = rowData.services.map((service: PaymentDetailsAwbsServices, index: number) => (
                    <div key={ index } className={ cartStyles.feeName }>
                      { getAdditionalServiceName(service.type) }:
                      { service.type === 'other' || service.type === 'gha_adjust' ? ' ' + service.params.reason : '' }
                    </div>
                  ));
                
                  return <div>{ fees }</div>;
                }
              },
              { title: 'Details', field: 'details', cellStyle: { paddingTop: '10px', verticalAlign: 'top' },
                render: (rowData: PaymentDetailsAwbs) => {

                  const dues: Array<JSX.Element> = rowData.services.map((service: PaymentDetailsAwbsServices, index: number) => (
                    <div key={ index } className={ cartStyles.dueRow }>
                      <div>{ getAdditionalServiceDetails(service, 0) }</div>
                    </div>
                  ));

                  return <div>{ dues }</div>;
                }
              },
              { title: 'Amount', field: '', cellStyle: { paddingTop: '10px',verticalAlign: 'top', textAlign: 'right' },
                render: (rowData: PaymentDetailsAwbs) => {

                  const amount: Array<JSX.Element> = rowData.services.map((service: PaymentDetailsAwbsServices, index: number) => (
                    <div key={ index } className={ `${ cartStyles.dueRow } ${ commonStyles.fJustifyEnd }` }>
                      <div>$</div> 
                      <div>{ formatCurrency(service.amount, 2,) }</div>
                    </div>
                  ));

                  return (
                    <div>
                      { amount }
                      <div className={ `${ cartStyles.dueRow } ${ cartStyles.dueSumRow } ${ commonStyles.fJustifyEnd }` }>
                        <div>$</div> 
                        <div>{ formatCurrency(rowData.total_amount, 2,) }</div>
                      </div>
                    </div>
                  )
                }
              }		
            ]}

            data = { props.payments.awbs }

            options = {{
              paging: false,
              showTitle: false,
              toolbar: false,
              headerStyle: {
                backgroundColor: 'var(--tbl_head_bkg)',
                color: 'var(--tbl_head_color)',
                zIndex: 2,
              }      
            }}
          />
          <div className={ style.total }>{ formatCurrency(props.payments.total_amount , 2, '$') }</div>
        </div> 
        </div>
        <div className={`${style.buttonContainerProcess}`}>
          <button className={style.processButton} onClick={props.handleClose}>Close</button>
          <button className={style.processButton} onClick={ () => props.cancelOrder() }>Process Credit to eWallet</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default withStyles(styles)(creditWalletModal);